import { TCardEntry } from 'components-ui'
import { Types } from 'service-api'

export const getArrivalDepartureCards = (flexBookingConfs: Types.FlexBookingConfClientDto[] = []): TCardEntry[][] => {
  const cards = flexBookingConfs
    .slice()
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .filter((conf) => (conf.step as string) === 'ARRIVAL_DEPARTURE' && Boolean(conf.content?.trim()))
    .map<TCardEntry>((conf) => ({
      displayName: conf.displayName,
      content: conf.content,
      description: conf.description,
      type: conf.type || undefined,
    }))

  return cards.length ? [cards] : []
}
